<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template slot="clientStatus" slot-scope="scope">
        <el-tag :class="'client-status-class-' + scope.row.clientStatus">{{
          getClientStatusName(scope.row.clientStatus)
        }}</el-tag>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.carparkspace_new_add"
          @click="openCreateCar"
          >新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.carparkspace_delete"
          plain
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="parkSpaceInfoSync"
          >车场信息下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="monthCarChargeRuleSync"
          >月卡车收费规则下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="tempCarChargeRuleSync"
          >临停车收费规则下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="carPassRuleSync"
          >车辆通行规则下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="passageInfoSync"
          >通道信息下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="deviceInfoSync"
          >设备信息下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="ledSettingSync"
          >LED设置下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="ledTemplateSync"
          >LED模板信息下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="sentryBoxInfoSync"
          >岗亭信息下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="parkUserSync"
          >岗亭人员下发
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          :disabled="syncBtnDisabled"
          plain
          @click="parkGroupSync"
          >分组信息下发
        </el-button>
      </template>
      <template slot="mapForm" slot-scope="scope">
        <div>
          <BaiduMap
            :keyword="form.addr"
            :lat.sync="form.locationLatitude"
            :lng.sync="form.locationLongitude"
            :disabled="passCloseDialog"
          ></BaiduMap>
        </div>
      </template>

      <template slot="menu" slot-scope="scope">
        <!-- 删除该功能2023-6-12 -->
        <!-- <el-button
          type="text"
          size="small"
          v-if="
            (scope.row.equType === 4 || scope.row.equType === 3 || scope.row.equType === 6 || scope.row.equType === 7) &&
            permissionList.settingBtn
          "
          @click="parkBaseInfoSetting(scope.row)"
        >
          <span class="el-icon-setting"></span>车场配置
        </el-button> -->

        <el-button
          type="text"
          size="small"
          v-if="permission.carparkspace_new_edit"
          @click="newEdit(scope.row)"
        >
          <span class="el-icon-setting"></span>车场配置
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permission.carparkspace_new_edit"
          @click="configEdit(scope.row)"
        >
          <span class="el-icon-setting"></span>参数配置
        </el-button>
      </template>
      <template slot="contentForm">
        <VueEditor
          id="editor"
          :disabled="VueEditorDisabled"
          v-model="form.content"
          useCustomImageHandler
          @image-added="handleImageAdded"
        ></VueEditor>
      </template>
    </avue-crud>
    <sync-dialog ref="syncDialog" @closeSyncForm="onCloseSyncDialog"></sync-dialog>

    <car-park-base-info-dialog
      ref="carParkBaseInfoDialog"
      @closeParkBaseInfoDialot="onCloseParkBaseInfoDialot"
    ></car-park-base-info-dialog>
    <createCar @onload="onLoad(page)" ref="createCar"></createCar>

    <createConfig @onload="onLoad(page)" ref="createConfig"></createConfig>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/carv2/carparkspace';
import { putFile } from '@/api/crmedical/contract/add';
import { mapGetters } from 'vuex';
import syncDialog from '@/views/v4ward/carv2/carparkspace-sync-dialog';
import carParkBaseInfoDialog from '@/views/v4ward/carv2/merge/carParkBaseInfo';
import { VueEditor } from 'vue2-editor/dist/vue2-editor.core.js';
import BaiduMap from './map/baiduMap.vue';
import createCar from './create-car/index.vue';
import createConfig from './create-car/config.vue';
export default {
  components: { createCar, syncDialog, VueEditor, carParkBaseInfoDialog, BaiduMap,createConfig },
  name: 'carparkspace',
  data() {
    return {
      form: {
        addr: '',
      },
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      syncBtnDisabled: false,
      VueEditorDisabled: false,
      syncRowId: '',
      option: {
        height: 'auto',
        tip: true,
        tree: true,
        sarchShow: true,
        searchMenuSpan: 12,
        calcHeight: 30,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        refreshBtn: true,
        editBtn:false,
        labelWidth: 100,
        dialogHeight: 300,
        stripe: true,
        dialogClickModal: false,
        selectClearBtn: true,
        column: [
          {
            label: '车场名称',
            prop: 'spaceName',
            search: true,
            showWordLimit: true,
            editDisabled: true,
            maxlength: 20,
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '编号',
            prop: 'spaceCode',
            span: 12,
            showWordLimit: true,
            maxlength: 32,
            editDisabled: true,
            rules: [
              {
                required: true,
                message: '请输入编号',
                trigger: 'change',
              },
              {
                pattern: /^[a-zA-Z][a-zA-Z0-9]{5,31}$/,
                message: '编号只能包含字母和数字,且以字母开头,长度6-32',
              },
            ],
          },
          {
            label: '道闸品牌',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_brand',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'equType',
            rules: [
              {
                required: true,
                message: '请输入道闸品牌',
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: 'IoT网关ID',
          //   prop: 'iotGatewayId',
          //   span:12,
          //   showWordLimit:true,
          //   maxlength:100,
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入IoT网关ID',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: 'IOT网关ID',
            prop: 'iotGatewayId',
            hide: true,
            display: true,
            showWordLimit: true,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: '请输入IOT网关ID',
                trigger: 'change',
              },
              { pattern: /^[^\u4e00-\u9fa5]+$/, message: '格式错误' },
            ],
          },
          {
            label: '所属部门',
            type: 'tree',
            span: 12,
            dicUrl: '/api/base/deptproperty/tree',
            prop: 'deptId',
            props: {
              label: 'title',
              value: 'value',
              children: 'children',
            },
            rules: [
              {
                required: true,
                message: '请输入部门名',
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: '上级车场',
          //   prop: 'parentId',
          //   dicData: [],
          //   type: 'tree',
          //   hide: true,
          //   props: {
          //     label: 'title',
          //   },
          //   rules: [
          //     {
          //       required: false,
          //       message: '请选择上级车场',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          // {
          //   label: '车位数量',
          //   prop: 'parkLotNumber',
          //   width: 80,
          //   rules: [
          //     {
          //       required: false,
          //       message: '请输入停车场车位数',
          //       trigger: 'change',
          //     },
          //     { pattern: /^[+]?\d{1,6}$/, message: '格式错误' },
          //   ],
          // },
          {
            label: '所属小区',
            type: 'tree',
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
            props: {
              label: 'title',
              value: 'id',
            },
            prop: 'areaId',
            rules: [
              {
                required: true,
                message: '请选择所属小区',
              },
            ],
          },
          {
            label: '状态',
            prop: 'clientStatus',
            display: false,
            width: 80,
            slot: true,
            editDisabled: true,
            addDisabled: true,
          },
          {
            label: '平台验证码',
            prop: 'code',
            editDisplay: false,
            addDisplay: false,
            hide: true,
            width: 200,
            span: 24,
            editDisabled: true,
            addDisabled: true,
          },
          {
            label: '车场排序',
            prop: 'sort',
            width: 80,
            hide: true,
            maxlength: 9,

            rules: [
              {
                required: false,
                message: '请输入车场排序字段',
                trigger: 'change',
              },
              { pattern: /^[+]?\d{1,6}$/, message: '格式错误' },
            ],
          },
          {
            label: '启用当前时间',
            prop: 'useNowDate',
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=switch',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 100,
            rules: [
              {
                required: true,
                message: '车场过期月卡车启用当前日期续费,0 不启用，1 启用',
                trigger: 'change',
              },
            ],
          },
          {
            label: '月卡车审核',
            prop: 'useReview',
            type: 'radio',
            dicData: [
              {
                label: '启用',
                value: 0,
              },
              {
                label: '停用',
                value: 1,
              },
            ],
            hide: true,
            rules: [
              {
                required: true,
                message: '请选择是否开启月卡车审核',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车场位置',
            prop: 'addr',
            overHidden: true,
            span: 24,
            showWordLimit: true,
            maxlength: 150,
            rules: [
              {
                required: true,
                message: '请输入车场位置',
                trigger: 'change',
              },
            ],
          },
          {
            label: '',
            prop: 'map',
            span: 24,
            hide: true,
            formslot: true,
          },
          {
            label: '经度',
            prop: 'locationLongitude',
            disabled: true,
            span: 12,
          },
          {
            label: '纬度',
            prop: 'locationLatitude',
            disabled: true,
            span: 12,
          },
          {
            label: '收费规则',
            prop: 'content',
            hide: true,
            row: true,
            span: 24,
            maxlength: 2000,
            required: true,
            formslot: true,
            rules: [
              {
                required: true,
                message: '请填写收费规则',
                trigger: 'change',
              },
              { max: 2000, message: '请控制在2000个字符内', trigger: 'change' },
            ],
          },

          /*
          {
            label: '道闸编号',
            prop: 'blockLocalNo',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入道闸车场本地编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '临停规则',
            prop: 'parkStandardLocalNoLt',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入道闸本地临停收费规则',
                trigger: 'change',
              },
            ],
          },
          {
            label: '月卡规则',
            prop: 'rentStandardLocalNo',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入道闸本地月租车收费规则',
                trigger: 'change',
              },
            ],
          },
          {
            label: '道闸群组',
            prop: 'groupLocalNoZero',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入道闸本地  地面停车场群组',
                trigger: 'change',
              },
            ],
          },
          {
            label: '道闸车组',
            prop: 'groupLocalNoOne',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入道闸本地  地下一车组',
                trigger: 'change',
              },
            ],
          },*/
        ],
      },
      passCloseDialog: false,
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carparkspace_add, false),
        newaddBtn: this.vaildData(this.permission.carparkspace_new_add, false),
        viewBtn: this.vaildData(this.permission.carparkspace_view, false),
        delBtn: this.vaildData(this.permission.carparkspace_delete, false),
        editBtn: this.vaildData(this.permission.carparkspace_edit, false),
        neweditBtn: this.vaildData(this.permission.carparkspace_new_edit, false),
        syncBtn: this.vaildData(this.permission.carparkspace_sync, false),
        settingBtn: this.vaildData(this.permission.carparkpace_baseinfo, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[4].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 350) {
            this.option.height = this.bodyHeight - 290;
          } else {
            this.option.height = this.bodyHeight - 350;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.dialogHeight = this.bodyHeight - 360;
    this.option.height = this.bodyHeight - 350;
  },
  updated() {
    if (this.$router.currentRoute.fullPath == '/v4ward/carv2/carparkspace') {
      setTimeout(() => {
        let body = this.$refs.crud.$children[4].$el.childNodes[0].querySelector('.el-dialog__body');
        let menu = Array.from(document.getElementsByClassName('avue-form__menu'))[1];
        let temFooterDom =
          this.$refs.crud.$children[4].$el.childNodes[0].querySelector('#temFooterDom');
        console.log(temFooterDom);
        if (temFooterDom) {
          temFooterDom.remove();
        }
        if (body && menu && !this.passCloseDialog) {
          menu.className = 'avue-form__menu avue-form__menu--right';
          let footerDom = document.createElement('div');
          footerDom.className = 'el-dialog__footer';
          footerDom.id = 'temFooterDom';
          footerDom.append(menu);
          body.append(footerDom);
          // menu.remove();
        }
      });
    }
  },
  watch: {
    "form.equType"(){
      if (this.form.equType == 7 || this.form.equType == 8) {
        this.option.column[3].display = false;
        this.option.iotGatewayId = '';
      }else{
        this.option.column[3].display = true;
        this.option.iotGatewayId = '';
      }
    },
  },
  methods: {
    newEdit(row) {
      this.$refs.createCar.openDialog('edit', row);
    },
    configEdit(row){
      this.$refs.createConfig.openDialog('edit', row);

    },
    openCreateCar() {
      this.$refs.createCar.openDialog('add');
    },
    onCloseParkBaseInfoDialot() {
      console.log('onCloseParkBaseInfoDialot');
    },
    parkBaseInfoSetting(row) {
      this.$refs.carParkBaseInfoDialog.openDialogForm(row);
      setTimeout(() => {
        document.querySelector(
          '#avue-view > div > div > div > div.basic-container.car-park-base-info-dia > div > div > div.el-dialog__wrapper > div > div.el-dialog__body'
        ).style = 'padding-top:5px !important';
      });
    },
    // 富文本处理图片上传问题
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      if (this.VueEditorDisabled) {
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      // 通过上传接口返回url，将url放入富文本编辑器中
      putFile(formData)
        .then((res) => {
          let url = res.data.link;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onCloseSyncDialog() {
      console.log('----close---');
    },
    parkGroupSync() {
      this.openSyncDialog('车辆分组信息同步', 11);
    },
    ledTemplateSync() {
      this.openSyncDialog('LED语音模板信息同步', 10);
    },
    ledSettingSync() {
      this.openSyncDialog('LED语音设置信息同步', 9);
    },
    deviceInfoSync() {
      this.openSyncDialog('车场设备信息同步', 8);
    },
    parkUserSync() {
      this.openSyncDialog('车场人员信息同步', 7);
    },
    sentryBoxInfoSync() {
      this.openSyncDialog('岗亭信息同步', 6);
    },
    passageInfoSync() {
      this.openSyncDialog('通道信息同步', 5);
    },
    carPassRuleSync() {
      this.openSyncDialog('车辆通行规则信息同步', 4);
    },
    tempCarChargeRuleSync() {
      this.openSyncDialog('临停车收费规则信息同步', 3);
    },
    monthCarChargeRuleSync() {
      this.openSyncDialog('月卡车收费规则信息同步', 2);
    },
    parkSpaceInfoSync() {
      this.openSyncDialog('车场信息同步', 1);
    },
    //type : 1-车场信息，2-月卡车收费规则信息，3-临停车收费规则信息，4-通行规则设置 5-通道信息，6-岗亭信息
    // 7-车场人员信息, 8-车场设备信息, 9-LED 设置信息, 10-LED模板内容信息 11-车辆分组信息
    openSyncDialog(title, type) {
      this.$refs.syncDialog.openSyncDialogForm(title, type, this.syncRowId);
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          this.passCloseDialog = true;
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          this.passCloseDialog = true;
          loading();
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: '操作成功!',
          });
          this.$refs.crud.toggleSelection();
        });
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
      if (this.selectionList.length === 1) {
        let rowData = this.selectionList[0];
        if (rowData.equType === 4 && rowData.parentId === '0') {
          this.syncRowId = rowData.id;
          this.syncBtnDisabled = false;
        } else {
          this.syncRowId = '';
          this.syncBtnDisabled = true;
        }
      } else {
        this.syncRowId = '';
        this.syncBtnDisabled = true;
      }
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeClose(done, type) {
      if (this.passCloseDialog) {
        done();
      } else {
        this.$confirm('确定关闭页面?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            done();
          })
          .then(() => {});
      }
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(({ data }) => {
          this.form = data;
        });
      }
      if (type == 'view') {
        this.passCloseDialog = true;
        this.VueEditorDisabled = true;
      } else {
        this.passCloseDialog = false;
        this.VueEditorDisabled = false;
      }
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          /*getSpaceTree().then(({ data }) => {
            const index = this.$refs.crud.findColumnIndex('parentId');
            this.option.column[index].dicData = data;
          });*/
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    getClientStatusName(clientStatus) {
      if (clientStatus === 1) {
        return '在线';
      } else if (clientStatus === 2) {
        return '离线';
      } else if (clientStatus === 4) {
        return '查询失败';
      } else {
        return '其它';
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
</style>
<style>
.client-status-class-1 {
  width: 54px;
  background-color: #daffde;
  color: green;
}
.client-status-class-2 {
  width: 54px;
  background-color: #ffffff;
  color: #000000;
}
.client-status-class-3 {
  width: 54px;
  background-color: #fffff0;
  color: rgba(0, 0, 0, 0.29);
}
.client-status-class-4 {
  width: 54px;
  background-color: #fff0ff;
  color: #ff0000;
}
</style>
